// extracted by mini-css-extract-plugin
module.exports = {"container":"dialog_container__akeTs","overlay":"dialog_overlay__T5LRo","dialog":"dialog_dialog__fWf8q","closeButton":"dialog_closeButton__Lr85t"};